import {Injectable} from '@angular/core';
import {AuthStrategy} from '../../smoothr-web-app-core/models/AuthStrategy';
import {CompressedStorageService} from '../../smoothr-web-app-core/services/compression';
import {Api} from '../../smoothr-web-app-core/api/api';


@Injectable({
	providedIn: 'root'
})
export class HelloAgainService {

	get isUserRedirectedFromHelloAgain() {
		return this.compressedStorageService.getItem(AuthStrategy.HELLOAGAIN);
	}

	constructor(
		private compressedStorageService: CompressedStorageService
	) {}

	finishRedirectProcess() {
		this.compressedStorageService.removeItem(AuthStrategy.HELLOAGAIN);
	}

	async runUserAuthorization(trackUseRedirect = false) {
		// First try auto-login with React Native webview token
		if (window.ReactNativeWebView) {
			const autoLoginSuccess = await this.autoLoginWithWebViewToken();
			if (autoLoginSuccess) {
				return; // Auto-login successful, no need for redirect
			}
			// If auto-login fails, proceed with normal flow
		}

		// Normal authorization flow
		const res = await Api.loginHelloAgain(AuthStrategy.HELLOAGAIN).catch(err => console.error(err));
		if (trackUseRedirect) this.compressedStorageService.setItem(AuthStrategy.HELLOAGAIN, true);
		if (res) window.location.href = res.data.url;
	}

async autoLoginWithWebViewToken(): Promise<boolean> {
		return new Promise((resolve) => {
			// Check if running in React Native WebView
			if (!window.ReactNativeWebView) {
				resolve(false);
				return;
			}

			let tokenReceived = false;

			const initialize = async (item: any) => {
				if (item.accessToken) {
					tokenReceived = true;
					try {
						const res = await Api.helloAgainAuthorize(AuthStrategy.HELLOAGAIN, item.accessToken);
						console.log('Auto-login successful:', res);
						resolve(true);
					} catch (error) {
						console.error('Auto-login failed:', error);
						resolve(false);
					}
				}
			};

			// Set up message listeners
			document.addEventListener('message', function (e: any) {
				try {
					const item = JSON.parse(e.data);
					initialize(item);
				} catch (error) {
					console.error('Failed to parse message:', error);
				}
			});

			window.addEventListener('message', function (e: MessageEvent) {
				try {
					const item = JSON.parse(e.data);
					initialize(item);
				} catch (error) {
					console.error('Failed to parse message:', error);
				}
			});

			// Request the access token from React Native
			window.ReactNativeWebView.postMessage(JSON.stringify({
				action: 'getAccessToken',
			}));

			// Timeout after 10 seconds
			setTimeout(() => {
				if (!tokenReceived) {
					console.log('No token received within timeout period');
					resolve(false);
				}
			}, 10000);
		});
	}
}
